<div class="container">
    <div class="filters">
        <form [formGroup]="filters">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'admin.account-management.id' | translate }}</mat-label>
                <input matInput formControlName="id" maxlength="6">
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'admin.account-management.email' | translate }}</mat-label>
                <input matInput formControlName="email" maxlength="100">
            </mat-form-field>

            <app-company-document [controlName]="'document'" [label]="('admin.account-management.document' | translate)" [showIcon]="false" [required]="false"></app-company-document>

            <button mat-flat-button class="blue-flat-button" (click)="clickFilter()">{{'filter' | translate}}</button>
        </form>
    </div>
    <div class="content">
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="demo-table" mat-sort>
            <ng-container matColumnDef="column-id">
                <th class="column-id" mat-header-cell *matHeaderCellDef> {{ 'admin.account-management.id' | translate }}</th>
                <td class="id" mat-cell *matCellDef="let element"> {{element.id}}</td>
            </ng-container>

            <ng-container matColumnDef="column-email">
                <th class="column-email" mat-header-cell *matHeaderCellDef> {{ 'admin.account-management.email' | translate }}</th>
                <td class="email" mat-cell *matCellDef="let element"> {{element.email}}</td>
            </ng-container>

            <ng-container matColumnDef="column-document">
                <th class="column-document" mat-header-cell *matHeaderCellDef> {{ 'admin.account-management.document' | translate }}</th>
                <td class="document" mat-cell *matCellDef="let element"> {{element.document | DocumentFormatPipe}}</td>
            </ng-container>

            <ng-container matColumnDef="column-account-type">
                <th class="column-account-type" mat-header-cell *matHeaderCellDef> {{ 'admin.account-management.account-type' | translate }}</th>
                <td class="account-type" mat-cell *matCellDef="let element"> {{ 'admin.account-management.account-types.'+element.accountTypeId | translate }}</td>
            </ng-container>

            <ng-container matColumnDef="column-account-active">
                <th class="column-account-active" mat-header-cell *matHeaderCellDef> {{ 'admin.account-management.account-active' | translate }}</th>
                <td class="account-active" mat-cell *matCellDef="let element">
                    <span *ngIf="element.accountActive" class="active-icon"><p>A</p><span class="tooltip">{{'admin.account-management.active' | translate}}</span></span>
                    <span *ngIf="!element.accountActive" class="inactive-icon"><p>I</p><span class="tooltip">{{'admin.account-management.inactive' | translate}}</span></span>
                </td>
            </ng-container>

            <ng-container matColumnDef="column-options">
                <th class="column-options" mat-header-cell *matHeaderCellDef></th>
                <td class="options" mat-cell *matCellDef="let element">
                    <button mat-button class="menuButton" [matMenuTriggerFor]="dropdownMenu"  [matMenuTriggerData]="{ account: element }">
                        <mat-icon class="iconMenu">more_vert</mat-icon>
                    </button>
                </td>
                <mat-menu #dropdownMenu="matMenu" xPosition="before" yPosition="below">
                    <ng-template matMenuContent let-account="account">
                        <button mat-menu-item (click)="clickChangeAccountEmail(account)">
                            {{ 'admin.account-management.options.change-account-email' | translate }}
                        </button>
                        <button mat-menu-item (click)="clickChangeAccountType(account)">
                            {{ 'admin.account-management.options.change-account-type' | translate }}
                        </button>
                        <button mat-menu-item (click)="clickChangeAccountActive(account)">
                            {{ 'admin.account-management.options.change-account-active' | translate }}
                        </button>
                        <button mat-menu-item (click)="clickCheckClientsInformations(account)">
                            Informações do Cliente
                        </button>
                    </ng-template>
                </mat-menu>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    {{ 'none-found' | translate }}
                </td>
            </tr>
        </table>
        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="paginationChange($event)" aria-label="Selecionar página">
        </mat-paginator>
    </div>
</div>

<ng-template #changeAccountTypeDialog let-data>
    <div class="modal-header">
        <h2>{{ 'admin.account-management.options.change-account-type' | translate }}</h2>
        <button mat-button class="x-close-button" mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
    <p>{{ ('admin.account-management.actual-account-type' | translate) +": "}}
        <strong>{{ 'admin.account-management.account-types.'+data.account.accountTypeId | translate }}</strong>
    </p>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'admin.account-management.account-type' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedAccountType" #accountTypeSelect="ngModel" required cdkFocusInitial >
            <mat-option *ngFor="let option of getAccountTypesOptions(data.account.accountTypeId)" [value]="option.id">
              {{ option.id > 0 ? ('admin.account-management.account-types.'+option.id | translate) : ("select" | translate) }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="accountTypeSelect.errors != null ? accountTypeSelect.errors['required'] : false">
            {{ 'Selecione um tipo de conta' | translate }}
        </mat-error>
    </mat-form-field>
    <div class="modal-buttons-container">
        <button mat-button class="blue-flat-button" (click)="confirmChangeAccountType(data.account)">{{ 'change' | translate }}</button>
        <button mat-button mat-dialog-close class="close-button">{{ 'cancel' | translate }}</button>
    </div>
</ng-template>

<ng-template #changeAccountActiveDialog let-data>
    <div class="modal-header">
        <h2>{{ 'admin.account-management.options.change-account-active' | translate }}</h2>
        <button mat-button class="x-close-button" mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
    <p>{{ ('admin.account-management.actual-account-active' | translate) +": "}}
        <strong>{{ 'admin.account-management.'+(data.account.accountActive ? "active" : "inactive") | translate }}</strong>
    </p>
    <button mat-button class="blue-flat-button" [ngClass]="{ 'activate-button': data.account.accountActive == false, 'inactivate-button': data.account.accountActive == true }"
        (click)="confirmChangeAccountActive(data.account, data.account.accountActive ? false : true)" cdkFocusInitial>
        {{ 'admin.account-management.'+(data.account.accountActive == true ? "inactivate-account" : "activate-account" ) | translate }}
    </button>
</ng-template>

<ng-template #changeAccountEmailDialog let-data>
    <div class="modal-header">
        <h2>{{ 'admin.account-management.options.change-account-email' | translate }}</h2>
        <button mat-button class="x-close-button" mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
    <p class="change-email-warning">{{ 'admin.account-management.change-email-warning' | translate }}</p>
    <mat-form-field appearance="outline" class="full-width" style="display: block;">
        <mat-label>{{ 'admin.account-management.email' | translate }}</mat-label>
        <input matInput [(ngModel)]="newAccountEmail" maxlength="100" type="email" cdkFocusInitial>
    </mat-form-field>

    <form [formGroup]="changeAccountDocumentForm">
        <app-company-document [controlName]="'document'" [label]="('admin.account-management.document' | translate)" [showIcon]="false" [required]="false"></app-company-document>
    </form>
    <div class="modal-buttons-container">
        <button mat-button class="blue-flat-button" (click)="confirmChangeAccountEmailAndDocument(data.account)">{{ 'change' | translate }}</button>
        <button mat-button mat-dialog-close class="close-button">{{ 'cancel' | translate }}</button>
    </div>
</ng-template>